{
    "Accessibility menu": "पहुंच मेनू",
    "Reset settings": "सेटिंग्स रीसेट करें",
    "Close": "बंद करें",
    "Content adjustments": "सामग्री समायोजन",
    "Navigation adjustments": "नेविगेशन समायोजन",
    "Align Left": "बाईं ओर संरेखित करें",
    "Adjust Font Size": "फॉन्ट आकार समायोजित करें",
    "Highlight Title": "शीर्षक हाइलाइट करें",
    "Highlight Links": "लिंक हाइलाइट करें",
    "Readable Font": "पठनीय फॉन्ट",
    "Colour adjustments": "रंग समायोजन",
    "Dark Contrast": "गहरा कंट्रास्ट",
    "Light Contrast": "हल्का कंट्रास्ट",
    "High Contrast": "उच्च कंट्रास्ट",
    "High Saturation": "उच्च संतृप्ति",
    "Low Saturation": "कम संतृप्ति",
    "Monochrome": "मोनोक्रोम",
    "Tools": "उपकरण",
    "Reading Guide": "पठन मार्गदर्शिका",
    "Stop Animations": "एनिमेशन रोकें",
    "Big Cursor": "बड़ा कर्सर",
    "Increase Font Size": "फॉन्ट आकार बढ़ाएं",
    "Decrease Font Size": "फॉन्ट आकार घटाएं",
    "Letter Spacing": "अक्षर रिक्ति",
    "Line Height": "पंक्ति ऊंचाई",
    "Font Weight": "फॉन्ट वजन",
    "Dyslexia Font": "डिस्लेक्सिया फॉन्ट",
    "Language": "भाषा",
    "Accessibility widget": "पहुंच मेनू खोलें",
    "Accessibility Profiles": "पहुंच प्रोफाइल",
    "Cognitive Disability": "संज्ञानात्मक विकलांगता",
    "Seizure Safe": "मिर्गी सुरक्षित",
    "Accessibility statement": "पहुंच विवरण"
}